<header class="drag-bar" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <fa-icon icon="arrows-alt"></fa-icon>
    <h1 mat-dialog-title>Bedarf</h1>
    <span class="spacer"></span>
    <fa-icon class="close-button" icon="times" size="2x" matDialogClose></fa-icon>
</header>
<button app-round-button (click)="refreshArls()"><fa-icon icon="arrows-rotate"></fa-icon></button>
<div class="scroll-wrapper grow">
<table class="requirement-table">

        <tr>
            <th>Nr</th>
            <th>Bedarf</th>
            <th>Einheit</th>
            <th>Name</th>
            <th>{{ cls.getSingle$('Supplier') | async }}</th>
        </tr>

        <tr *ngFor="let row of tableData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ row.Sum }}</td>
            <td>{{ row.QuanityType }}</td>
            <td>{{ row.Name }}</td>
            <td>{{ row.Supplier }}</td>
        </tr>

</table>
</div>
